import Vue from 'vue';
import { mapState } from 'vuex';
import { ACTIVE, INACTIVE } from './state';
export default Vue.extend({
    computed: {
        ...mapState('accountLookup', ['result']),
        loginUrl() {
            return 'https://accounts.google.com/AccountChooser?hd=belajar.id';
        },
        firstAccount() {
            var _a, _b;
            return (_b = (_a = this.result) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b[0];
        },
        isActive() {
            var _a;
            return ((_a = this.firstAccount) === null || _a === void 0 ? void 0 : _a.status) === ACTIVE;
        },
        isInactive() {
            var _a;
            return ((_a = this.firstAccount) === null || _a === void 0 ? void 0 : _a.status) === INACTIVE;
        },
        hasPersonalEmail() {
            var _a;
            return !!((_a = this.result) === null || _a === void 0 ? void 0 : _a.personal_email);
        },
        noPersonalEmail() {
            return !this.hasPersonalEmail;
        },
        email() {
            var _a;
            return (_a = this.result) === null || _a === void 0 ? void 0 : _a.personal_email;
        },
        phoneNumber() {
            var _a;
            return (_a = this.result) === null || _a === void 0 ? void 0 : _a.phone_number;
        },
        activateText() {
            return this.isActive
                ? 'Akses Akun Pembelajaran'
                : 'Aktifkan Akun Pembelajaran saya';
        },
    },
});
